module.exports = __webpack_public_path__ + "static/media/lapiquera-miel-main.714fac27.jpg";